<div class="grid-container">
    @for (key of keys(); track $index) {
        @let control = form().controls[key];
        @let fieldData = fieldsData()[key];
        <!-- For readonly fields, set the row span to 1. This means that the field will only occupy one row in the grid. -->
        <div
            [attr.data-testid]="'grid-form-field grid-form-field-' + key"
            [style.gridColumnStart]="fieldData.position.x + 1"
            [style.gridColumnEnd]="'span ' + fieldData.position.cols"
            [style.gridRowStart]="fieldData.position.y + 1"
            [style.gridRowEnd]="'span ' + fieldData.position.rows"
            [class.full-width]="fieldData.position.cols >= 6">
            @switch (fieldData.type) {
                @case (FIELD_TYPES.Annotation) {
                    <app-froala [control]="$any(control)" [editmode]="false" />
                }
                @case (FIELD_TYPES.Table) {
                    <cipo-table-field [control]="$any(control)" [fieldData]="fieldData" [tableFieldId]="key" />
                }
                @case (FIELD_TYPES.Weather) {
                    <cipo-weather-table-field
                        [control]="$any(control)"
                        [fieldData]="fieldData"
                        [tableFieldId]="key"
                        [editMode]="!fieldData.readonly"
                        [date]="$any(form().controls[fieldData?.weatherDateId]?.value)"
                        [location]="$any(form().controls[fieldData?.weatherLocationId]?.value)" />
                }
                @default {
                    <cipo-control [control]="control" [fieldData]="fieldData" (onblur)="onBlur.emit(key)" />
                }
            }
        </div>
    }
</div>
